export default {
      id: "search-inform-usage",
      viewBox: "0 0 100 18",
      url: "assets/" + "sprite.svg#search-inform-usage",
      toString: function () {
        return this.url;
      }
    }